module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAUCAIAAABnBnglAAAA80lEQVRIx2NgsJhMDzRqzag1RCgScemkoTVirh1Aktly4rqFtnZxJXARalrDaDlp4Sxnn7Q8IJvXoZfHvpfVesKO5RaGYVVU9g2nbT8QoYlwoIoQi/5jA/8+bPn3cTtWqf9/Pvx70fv/z7v/pACGd2u3YKKP2/o+bp2IVerdus1f9+YBSeyyOBDDOUE1OiDsvvm0vfPT9i6sUu/Xr/qyu+T9hpWk+QZ73Hza8+/zARzh/Pfvs6b///6QFjd4koegUxdBESrkm/kzXVyTCuGlADDfbF5irRtSQ+V8I+TcLeDYjVwKiLp0ArMqrco0SCkwBEpoAJGVI0ljzEUDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/cv.png
// module id = 802
// module chunks = 0